import {AppConfig} from '../../../app/config/model/app-config.model';

export const APP_CONFIG: AppConfig = {
  version: '4.4.5-7c502d16158',
  loginUrl: '/authiam/login?roleattr=o&Location=',
  logoutUrl: '/authiam/logout',
  userUrl: '/site/rest/services/Geobasisdienste/SOE_GetUserAndRoles/MapServer/exts/GDI_GetUserAndRoles/CurrentUserInfo',
  storageKeyPrefix: 'ESTA_GIS_',
  cookiePrefix: 'IMMO_GIS_',
  rolePrefix: 'IMMOBILIEN',
  sidebarPortalLinkUrl: 'https://www.kkgeo.ch/geodaten/kantonale_geoportale',
  print: {
    printServiceUrl: '/site/rest/services/Geobasisdienste_PUBLIC/SimplePrint/GPServer/SimplePrint',
    layoutInfo: [
      {
        displayName: 'A4 Landscape',
        layout: 'SBB_Immobilien_A4_Landscape',
        width: 27.8,
        height: 17.5,
      },
      {
        displayName: 'A4 Portrait',
        layout: 'SBB_Immobilien_A4_Portrait',
        width: 19,
        height: 25,
      },
      {
        displayName: 'A3 Landscape',
        layout: 'SBB_Immobilien_A3_Landscape',
        width: 40,
        height: 25.4,
      },
      {
        displayName: 'A3 Portrait',
        layout: 'SBB_Immobilien_A3_Portrait',
        width: 27.7,
        height: 37.8,
      },
    ],
  },
  checkStatusSapId: '/site/rest/services/IMMOBILIEN/Verkaufsobjekte_SAP/MapServer/exts/IMMOGIS_Verkaufsobjekte_SAP/CheckStatus',
  sendVerkaufsObjekt: '/site/rest/services/IMMOBILIEN/Verkaufsobjekte_SAP/MapServer/exts/IMMOGIS_Verkaufsobjekte_SAP/SendVerkaufsobjekt',
  app_support: {
    label: 'Support / Fragen / questions / domande',
    kontakt: 'Christoph Gaam, SBB-IM Grundstücksmanagement',
    tel: 'Tel. +41 79 172 35 94, christoph.gaam@sbb.ch',
    beschreibung: 'Probleme mit Printscreen und Beschreibung melden. Signaler des problèmes avec un \'écran d\'impression et la description. Segnalare problemi con una schermata di stampa e la descrizione.',
    sharepoint: 'Immorail',
  },
  mailTo: {
    email: 'imke.tepperwien2@sbb.ch',
    subject: 'Anfrage aus ImmoGIS (Denkmalpflege)'
  },
  webGisApps: [
    {
      app: 'umwelt',
      name: 'Umwelt GIS'
    },
    {
      app: 'energie',
      name: 'Energie GIS'
    },
    {
      app: 'rcm',
      name: 'RCM Video'
    }
  ],
  language: [
    {
      lang: 'de',
      label: 'DE',
      default: true,
    },
    {
      lang: 'fr',
      label: 'FR',
      default: false,
    },
    {
      lang: 'it',
      label: 'IT',
      default: false,
    },
  ],
  translationConfig: {
    de: {
      lang: 'de',
      path: 'assets/i18n/de.json',
    },
    fr: {
      lang: 'fr',
      path: 'assets/i18n/fr.json',
    },
    it: {
      lang: 'it',
      path: 'assets/i18n/it.json',
    },
  },
  esri: {
    trustedServers: [
      'geo-dev.sbb.ch',
      'geo-int.sbb.ch',
      'geo.sbb.ch',
      'i89765.sbb.ch:5443',
      'dfamobile.sbb.ch',
    ],
    credentialsRequiredServers: [
      'geo-dev.sbb.ch',
      'geo-int.sbb.ch',
      'geo.sbb.ch',
    ],
  },
};
